// extracted by mini-css-extract-plugin
module.exports = {"headTile":"styles_headTile__37VAs","mainRow":"styles_mainRow__1XbAq","title":"styles_title__LSDAI","content":"styles_content__2Z3FW"};